import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { SORT_LIST } from '@/routes/photocard/_utils/data';
import { trackEvent } from '../Event/_lib/eventTrack';
import { Image } from '@/components/Image';

interface IProps {
  onClose: () => void;
}

const SortModal = ({ onClose }: IProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const sortValue = searchParams.get('sort') ?? SORT_LIST[0].name;

  function handleChangeRadio(sortItem: string) {
    searchParams.set('sort', sortItem);
    navigate(`${location.pathname}?${searchParams}`);
    onClose();

    trackEvent('PLP_click_Sort', {
      sort_name: sortItem
    });
  }

  return (
    <div
      className="w-[222px] h-[336px] rounded-[10px] border border-[#f5f5f5] flex flex-col justify-between items-center p-4 absolute top-[67px] right-[6px] gap-5 bg-white [box-shadow:10px_20px_20px_0px_rgba(0,0,0,0.16)] z-[100]"
      onClick={(e) => e.stopPropagation()}
    >
      {SORT_LIST.map((item) => {
        return (
          <div
            key={item.name}
            className={`flex justify-between w-full text-[16px] font-medium ${
              item.name === sortValue ? 'text-[#262626]' : 'text-[#999]'
            }`}
            onClick={() => handleChangeRadio(item.name)}
          >
            <FormattedMessage id={item.name} defaultMessage={SORT_LIST[0].name} />
            {item.name === sortValue && <Image alt={'check-line-svg'} width={20} height={20} src={'/icons/check-line.svg'} />}
          </div>
        );
      })}
    </div>
  );
};

export default SortModal;
